import { type MCPServerInfo } from '../../types';

const JfrogServer: MCPServerInfo = {
  serverId: 'JFROG',
  name: 'JFrog',
  slug: 'jfrog',
  description:
    'Official JFrog MCP server. Manage repositories, builds, runtime clusters, security scanning, and package curation.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/jfrog/mcp-jfrog',
    commitSha: 'e5047da',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['jfrogAccessToken', 'jfrogUrl'],
    properties: {
      jfrogAccessToken: {
        type: 'string',
        description: 'JFrog Access Token',
        sensitive: true
      },
      jfrogUrl: {
        type: 'string',
        description: 'JFrog Platform URL (e.g. https://mycompany.jfrog.io)',
        sensitive: false
      }
    }
  }
};

export default JfrogServer;
